import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { TableCell, TableRow } from '@mui/material';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { useModal } from 'mui-modal-provider';
import { useDeleteUserContactStatuses } from '../../../../sic-lib/api/hooks/useUserContactStatuses';
import { ContactStatus } from '../../../../sic-lib/types/ContactStatus';
import DialogConfirmAction from '../../../Shared/DialogConfirmAction/DialogConfirmAction';

interface Props {
    status: ContactStatus;
    onToggleHandler: () => void;
}

export default function ContactStatusDisplay({ status, onToggleHandler }: Props) {
    const { showModal } = useModal();
    const { mutate: deleteMutation, isPending: isDeleteLoading } = useDeleteUserContactStatuses();

    const handleDelete = async () => {
        const modal = showModal(DialogConfirmAction, {
            title: 'Delete Status',
            description: 'This status will be permanently deleted',
            onConfirm: async () => deleteMutation(status.statusId),
            onCancel: () => {
                modal.hide();
            },
        });
    };

    return (
        <TableRow>
            <TableCell>
                <Typography component="h3" variant="subtitle1">
                    {status.status}
                </Typography>
            </TableCell>
            <TableCell align="right">
                <Grid container flexDirection="row" justifyContent="flex-end">
                    <Grid item>
                        <Tooltip title="Edit">
                            <IconButton size="small" onClick={onToggleHandler}>
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    <Grid item>
                        <Tooltip title="Delete">
                            <IconButton size="small" onClick={handleDelete}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </TableCell>
        </TableRow>
    );
}
